// Статус оповещения
export enum NotificationStatusEnum {
  Success,
  Error
}
